import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_40kn3wg5wx: FaireBrandEntity = {
  token: "b_40kn3wg5wx",
  type: "brand",
  name: "SOAP CHERIE",
  avatarUrl:
    "https://cdn.faire.com/fastly/79942c6c3e88faad95be884c3a26a75762c12598b77941a0e7f7c2abe2296f88.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/85c3298466e817801900a7323e200a690fb082f7e01487a1f86403d87b6e834b.png",
  logoUrl:
    "https://cdn.faire.com/fastly/79942c6c3e88faad95be884c3a26a75762c12598b77941a0e7f7c2abe2296f88.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/85c3298466e817801900a7323e200a690fb082f7e01487a1f86403d87b6e834b.png",
  location: "BROOKLYN, NY, USA",
  minimumOrderDollars: 890,
  rating: 5,
  reviewCount: 29,
  isInsider: true,
  description:
    "Soap Cherie was born out of a passion for natural skincare and self-care, crafted by two best friends from completely different walks of life. Frustrated with the struggle of finding solutions for sensitive skin, Limor and Jennifer started experimenting with herbal remedies and simple, nature-inspired ingredients.\n\nThe result? A wellness brand that delivers skin-loving, feel-good products you’ll actually want in your daily routine.\n\nFrom our playful bakery-inspired soaps to calming bath salts and our cult-favorite body scrubs, every product is designed and handcrafted with love in our Bushwick studio, right in the heart of Brooklyn, NY. Because self-care should always feel this good. 💖",
  meta: {
    source: "api",
    importedAt: "2026-04-19T21:45:00.182Z",
    importedBy: "entity-db-cli",
  },
};
